import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NormalModeService {
  private responseDataSubject = new BehaviorSubject<any>(null);
  private normalModeApiUrl = 'http://1'; // API for Normal Mode

  constructor(private http: HttpClient) {}

  fetchNormalModeData(): Observable<any> {
    return this.http.get<any>(this.normalModeApiUrl).pipe(
      tap((response) => {
        this.setResponseData(response);
        console.log('Response set in NormalModeService:', response);
      })
    );
  }

  setResponseData(data: any) {
    this.responseDataSubject.next(data);
  }

  getResponseData(): Observable<any> {
    return this.responseDataSubject.asObservable();
  }
}
